import ApiResourceManager from '../ApiResourceManager';

/**
 * The restaurant's Online payment step (WLP Payments 5/8): its status, which of the
 * partner's connections it charges through, the hosted hand-off, and the
 * "take online payments?" answer.
 *
 * Company-scoped by the `x-on-behalf-of-company` header, like `/business-details`.
 */
export default class CompanyPaymentSetupManager extends ApiResourceManager {
  show = () =>
    this.request({
      method: 'GET',
      url: '/company/payment-setup',
    });

  /**
   * `companyId` overrides the header for the partner's Restaurants table, which
   * links rows other than the restaurant the dashboard is currently on.
   */
  linkConnection = (connectionId, companyId = undefined, { pauseOnlinePayments = false } = {}) =>
    this.request({
      method: 'PUT',
      url: '/company/gateway-connection',
      data: { connection_id: connectionId, ...(pauseOnlinePayments && { pause_online_payments: true }) },
      ...(companyId && { headers: { 'x-on-behalf-of-company': companyId } }),
    });

  /**
   * Back to "Not set up", leaving the gateway connected for the partner's other restaurants.
   * A live restaurant is refused with `restaurant_live` unless `pauseOnlinePayments` confirms it.
   */
  unlinkConnection = (companyId, { pauseOnlinePayments = false } = {}) =>
    this.request({
      method: 'DELETE',
      url: '/company/gateway-connection',
      data: pauseOnlinePayments ? { pause_online_payments: true } : undefined,
      headers: { 'x-on-behalf-of-company': companyId },
    });

  createOnboardingLink = (returnUrl) =>
    this.request({
      method: 'POST',
      url: '/company/gateway-onboarding-link',
      data: { return_url: returnUrl },
    });

  /** The payout bank account, masked: the number itself never comes back. */
  bankAccount = () =>
    this.request({
      method: 'GET',
      url: '/company/payout-bank-account',
    });

  updateBankAccount = (data) =>
    this.request({
      method: 'PUT',
      url: '/company/payout-bank-account',
      data,
    });

  setOnlinePayments = (enabled) =>
    this.request({
      method: 'PUT',
      url: '/company/online-payments',
      data: { enabled },
    });
}
